import React from 'react';
import GetAppIcon from '@mui/icons-material/GetApp';
import { exportGridsToExcel } from 'routes/BudgetModule/contexts/helpers';
import { useGridApiContext } from 'routes/BudgetModule/contexts/GridApiContext';
import { trackEventBudget } from 'helpers/trackerHelpers';
import { StyTooltipIconButton } from './ExportButton';
import { useTranslation } from 'react-i18next';
import { useSelectSecondaryBudgetAxisSourceTable } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableContext';
import { translateBlock } from 'i18n';
import { FALLBACK_SECONDARY_BUDGET_AXIS_DISPLAY } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableProvider';
import { pluralize } from 'helpers/formatHelper';

type Props = {
    fileName: string;
    event?: string;
    setShouldShowOpenedGroups?: (shouldShowOpenedGroups: boolean) => void;
};

const ExportButtonMultipleGrid = ({
    fileName,
    event,
    setShouldShowOpenedGroups = undefined,
}: Props): React.ReactElement => {
    const [gridContext] = useGridApiContext();
    const { t } = useTranslation();
    const sourceTable = useSelectSecondaryBudgetAxisSourceTable();
    const sourceTableLabel = sourceTable
        ? translateBlock(sourceTable)
        : FALLBACK_SECONDARY_BUDGET_AXIS_DISPLAY;
    return (
        <StyTooltipIconButton
            tooltip={t('common.export')}
            onClick={() => {
                if (setShouldShowOpenedGroups) setShouldShowOpenedGroups(true);
                else
                    exportGridsToExcel(
                        gridContext[fileName],
                        fileName,
                        pluralize(sourceTableLabel),
                    );
                if (event) trackEventBudget(event);
            }}
            icon={<GetAppIcon />}
            isDisabled={gridContext[fileName]?.sheets.length === 0}
        />
    );
};

export default ExportButtonMultipleGrid;
